import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-pathway-dialog',
  templateUrl: './pathway-dialog.component.html',
  styleUrls: ['./pathway-dialog.component.css']
})
export class PathwayDialogComponent implements OnInit {

  hoveredRects = [];

  constructor(
    private dialogRef: MatDialogRef<PathwayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.hoveredRects = data.hoveredRects;
    }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
